// src/components/Shared/Question.js

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Answer from './Answer';
import styles from '../Exam/Exam.module.css';

const Question = ({
    question,
    answers,
    selectedAnswers,
    handleAnswerSelection,
    image,
    isSingleChoice
}) => {
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        setImageError(false);
    }, [image]);

    return (
        <div className={styles.question}>
            <h2>{question}</h2>
            {image && (
                <div className={styles.questionImageWrapper}>
                    {!imageError ? (
                        <img
                            src={`/images/${image}`}
                            alt={`Ilustracja do pytania: ${question}`}
                            className={styles.questionImage}
                            onError={() => setImageError(true)}
                        />
                    ) : (
                        <div className={styles.questionImageFallback}>
                            Brak ilustracji do tego pytania (sprawdź poprawność nazwy pliku: <span style={{ fontFamily: "monospace" }}>{image}</span>)
                        </div>
                    )}
                </div>
            )}
            <ul className={styles.answers}>
                {answers.map((answer, index) => (
                    <Answer
                        key={index}
                        answer={answer}
                        index={index}
                        isSelected={selectedAnswers.includes(index)}
                        handleAnswerSelection={handleAnswerSelection}
                        isSingleChoice={isSingleChoice}
                    />
                ))}
            </ul>
        </div>
    );
};

Question.propTypes = {
    question: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedAnswers: PropTypes.arrayOf(PropTypes.number).isRequired,
    handleAnswerSelection: PropTypes.func.isRequired,
    image: PropTypes.string,
    isSingleChoice: PropTypes.bool.isRequired
};

export default Question;
